import { useEventListener, useWindowSize } from 'usehooks-ts';

const addClassName = (elem: HTMLElement, className: string) => {
  if (!elem.className.includes(className)) {
    elem.className = `${elem.className} ${className}`;
  }
};

const removeClassName = (elem: HTMLElement, className: string) => {
  elem.className = elem.className.replace(className, '');
};

type Options = {
    enabled?: boolean
}

export function useHideOnScroll(elementId: string, { enabled = true }: Options = {}) {
  const { height = 0 } = useWindowSize();
  
  const handler = () => {
    if (!enabled) return;
    const nav = document.getElementById(elementId);
    if (!nav) return;
    const totalScrollHeight = document.body.offsetHeight - window.innerHeight;
    const scrollDiff = Math.abs(totalScrollHeight - window.scrollY);
    if (window.scrollY <= height || scrollDiff < 100) {
      removeClassName(nav, 'hidden');
      addClassName(nav, 'visible');
    } else {
      removeClassName(nav, 'visible');
      addClassName(nav, 'hidden');
    }
  }
  
  useEventListener('scroll', handler);
}
